module.exports = __webpack_public_path__ + "assets/img/37_1037_big.c03f8f18.jpg";